import { useMutation, useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'

import JourneyService from 'src/services/journeys.service'

import { IAccountByIdRespDto, IJourneyCreateFormDto } from 'src/types'
import { QUERY_KEYS } from 'src/constants'
import { mediaEntityUploadService } from 'src/services/media-entity-upload.service'
import { DEFAULT_LANGUAGE_CODE } from 'src/components/languages/langauges-list/constants'

const useAddJourney = (locale?: string) => {
  const queryClient = useQueryClient()
  const { accountId } = useParams()

  return useMutation(
    async ({ image, ...journey }: IJourneyCreateFormDto) => {
      const uploadedIcon = await mediaEntityUploadService.uploadIcon(image.file, image.icon)

      return JourneyService.createJourney({
        ...journey,
        account: accountId ?? '',
        image: uploadedIcon ? uploadedIcon[0] : image.icon || null,
        image_small: uploadedIcon ? uploadedIcon[1] : journey.image_small,
        image_medium: uploadedIcon ? uploadedIcon[2] : journey.image_medium,
      })
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEYS.JOURNEYS)

        queryClient.setQueryData(
          [QUERY_KEYS.ACCOUNT, accountId, locale ?? DEFAULT_LANGUAGE_CODE],
          (prev?: IAccountByIdRespDto) => {
            return prev
              ? { ...prev, journeysCount: ++prev.journeysCount }
              : ({} as IAccountByIdRespDto)
          },
        )
      },
    },
  )
}

export { useAddJourney }
